<template>
    <div class="context-container">
        <ul class="menu">
             <li v-for="(item, index) in menuItems" :key="index" class="nopads">
                <!-- Divider -->
                <div v-if="!item.text && !item.onClick" class="menu-divider"/>
                <div v-else-if="!item.subItems"
                     @click="!item.disabled ? passClick(item.onClick) : null"
                     :class="['menu-item', { active: activeView === item.viewName, 'disabled-item' : item.disabled }]">
                     <span class="menu-text px-1">{{ item.text }}</span>
                </div>
                <div v-else @click="toggleItem(item)" :class="['menu-item', { active: activeView === item.viewName }]">
                    <span class="menu-text px-1">{{ item.text }}</span>
                    <font-awesome-icon icon="chevron-right" class="submenu-indicator px-1" />
                </div>

                <div v-if="item.subItems && openItems.includes(item.text)" class="submenu-popup submenu-open submenu-map" :style="popupStyle(item)">
                    <ul class="submenu-item-popup">
                        <li v-for="(subItem, idx) in item.subItems" :key="idx">
                            <div v-if="!subItem.text && !subItem.onClick" class="menu-divider">
                                Nej satan
                            </div>
                            <div v-else class="submenu-item-content" :class="{'disabled-item' : subItem.disabled }" @click.stop="!subItem.disabled ? passClick(subItem.onClick) : null">
                                <span class="submenu-text">{{ subItem.text }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {ref, computed, nextTick, onMounted, onBeforeUnmount} from 'vue';
import {Tooltip} from "bootstrap";

export default {
    name: 'ContextMenu',
    props: {
        menuItems: {
            type: Array,
            default: []
        }
    },
    setup(props, { emit }) {
        const openItems = ref([]);
        const activeView = ref(null);

        const toggleItem = async (item) => {
            if (item.subItems) {
                if (openItems.value.includes(item.text)) {
                    openItems.value = openItems.value.filter(i => i !== item.text);
                } else {
                    openItems.value = []
                    openItems.value.push(item.text);
                }
                await nextTick();
            }
        };

        const hideSubmenu = (item) => {
            openItems.value = openItems.value.filter(i => i !== item.text);
        };

        return { openItems, activeView, toggleItem, hideSubmenu };
    },
    methods: {
        passClick(callback) {
            this.$emit('itemSelected', callback)
        },

        popupStyle(item) {
            const index = this.menuItems.findIndex(i => i.viewName === item.viewName)
            return {
                top: `${index * 40}px`
            }
        },

        getLanguage: function () {
            const lang = navigator.language.split('-')[0]
            switch (lang) {
                case 'en':
                    return 'en'
                case 'fi':
                    return 'fi'
            }
            return 'en'
        },
    }
};
</script>

<style scoped>
.context-container {
    width: 250px;
    background-color: rgba(43, 43, 43, 0.9) !important;
    border: 1px solid #000000;
    border-radius: .25em;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .88);
    backdrop-filter: blur(3px);
    font-size: .9em;
}

.menu {
    list-style: none;
    padding: 0;
    margin: 0;
}

.menu-item {
    display: flex;
    align-items: center;
    padding: .3em .5em;
    cursor: pointer;
    Transition: background 0.3s ease;
    white-space: nowrap;
    position: relative;
    color: #ffffff;
    font-size: 1em;
    border: none;
}

.menu-item:hover {
    background-color: #525252;
}

.menu-text {
    flex-grow: 1;
    text-align: left;
    padding-left: .2em;
    padding-right: .1em;
}

.submenu-item-popup {
    padding-left: 0;
    padding-right: 0;
    padding-top: .35em;
    padding-bottom: .35em;
    line-height: 1.6em;
    list-style: none;
    color: #FFFFFF;
}

.submenu-item-content {
    margin: 0;
    margin-left: .1em;
    padding: .1em 1em;
    cursor: pointer;
    color: #FFFFFF;
}

.submenu-item-content:hover {
    color: #a3ea18 !important;
}

.submenu-open {
    max-height: 500px;
    opacity: 1;
}
.submenu-text{
    cursor: pointer;
}
.submenu-indicator {
    font-size: 12px;
    margin-left: auto;
}

.submenu-popup {
    list-style: none;
    position: absolute;
    left: 100%;
    margin-top: -2em;
    margin-left: .3em;
    padding-left: .5em;
    color: #FFFFFF;
    background-color: rgba(43, 43, 43, 0.9) !important;
    border: 1px solid #404041;
    border-radius: .25em;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .88);
    min-width: 200px;
    max-width: 400px;
    border-top-right-radius: .3em;
    border-bottom-right-radius: .3em;
    Transition: opacity 0.3s ease, transform 0.3s ease;
    opacity: 0;
    display: none;
    overflow: visible;
    z-index: 1000;
    font-size: 1em;
}
.submenu-popup.submenu-open {
    opacity: 1;
    display: block;
}

@media (max-width: 576px) {
    .submenu-map {
        background-color: #000000 !important;
        left: 10%;
    }

}

.disabled-item {
    cursor: not-allowed !important;
    color: #BCBCBC !important;
}

.menu-divider {
    width: 90%;
    height: 1px;
    margin: auto;
    background-color: #BCBCBC;
}
</style>
